import { render, staticRenderFns } from "./OtherCostsEditForm.vue?vue&type=template&id=35807187"
import script from "./OtherCostsEditForm.vue?vue&type=script&lang=js"
export * from "./OtherCostsEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports